export const Bio = {
  name: "Harikaran",
  roles: ["FULLSTACK DEVELOPER", "REACTJS DEVELOPER", "MERN STACK"],
  description:
    "Experienced Software Development Engineer with a strong foundation in MERN stack development. Specialized in building scalable, efficient, and user-friendly web applications. Proven track record in developing robust solutions while maintaining high code quality standards. Passionate about creating innovative digital solutions and continuously expanding technical expertise. Skilled in both frontend and backend development, with a focus on delivering optimal user experiences. Collaborative team player with strong problem-solving abilities and a commitment to professional growth.",
  github: "https://github.com/HarikaranSubramanian",
  resume:
    "https://drive.google.com/file/d/1p5UIVaxYGwMbfYSA33bVsBDnQqoZLu4X/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/harikaran-subramanian-profile/",
  email: "harikaran7242@gmail.com",
  twitter: "https://twitter.com/harikaran7242",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Next.js",
        image:
          "https://seeklogo.com/images/N/next-js-logo-8FCFF51DD2-seeklogo.com.png",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/2048px-Tailwind_CSS_Logo.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "https://w7.pngwing.com/pngs/925/447/png-transparent-express-js-node-js-javascript-mongodb-node-js-text-trademark-logo.png",
      },
    ],
  },
  {
    title: "Database & Cloud",
    skills: [
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Supabase",
        image:
          "https://seeklogo.com/images/S/supabase-logo-DCC676FFE2-seeklogo.com.png",
      },
    ],
  },
  {
    title: "Tools & Others",
    skills: [
      {
        name: "Git",
        image:
          "https://i.pinimg.com/474x/66/8f/03/668f031e4dde7816c77d8e36b080a94f.jpg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Cursor",
        image:
          "https://sdmntprnorthcentralus.oaiusercontent.com/files/00000000-c11c-622f-b1ce-6b2e68c2528d/raw?se=2025-04-30T08%3A51%3A42Z&sp=r&sv=2024-08-04&sr=b&scid=713e041e-bbf3-5de5-9698-43317b8635dd&skoid=a3336399-497e-45e5-8f28-4b88ecca3d1f&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2025-04-30T04%3A47%3A45Z&ske=2025-05-01T04%3A47%3A45Z&sks=b&skv=2024-08-04&sig=CbSunOMYgRF7MCvYgQ4lEn003SuRPcZXmoQIS5Z4a5o%3D",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "Vercel",
        image:
          "https://i.pinimg.com/474x/70/3b/cd/703bcdcc38bea50d1bbaa4adbc7f279c.jpg",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://i.pinimg.com/474x/82/a0/d0/82a0d0900cb1a2801b2a0f5988991baf.jpg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 2,
    img: "https://media.licdn.com/dms/image/v2/D560BAQGGtIwzdI4Mhw/company-logo_200_200/company-logo_200_200/0/1716007607665?e=1751500800&v=beta&t=FQGZaqYGyfTNkxdnvr8DHwta3iq9bEYXUqKKoAPHvvg",
    role: "Software Development Engineer",
    company: "Maaya Analytics Pvt Ltd",
    date: "March 2025 - Present",
    desc: "Working as a Software Development Engineer at Maaya Analytics Pvt Ltd, focusing on developing and maintaining web applications using modern technologies. Contributing to the development of scalable and efficient solutions while collaborating with cross-functional teams.",
    skills: ["React", "Next.js", "Supabase", "Material UI"],
  },
  {
    id: 1,
    img: "https://i.pinimg.com/474x/ad/78/5a/ad785a9fb1587a496092b3d2f4e912b8.jpg",
    role: "Quality Specialist",
    company: "Amazon Development Centre (India)PVT LTD",
    date: "May 2024 - Jan 2025",
    desc: "Results-driven Quality Specialist with 1.4 years of experience at Amazon, specializing in quality control, data analysis, and process improvement. Proven expertise in workflow optimization, ensuring operational efficiency, and maintaining high-quality standards. Applied MERN stack development skills (MongoDB, Express.js, React.js, Node.js) to build internal tools and dashboards, enabling data automation, task optimization, and improved reporting accuracy. Adept at responsive web development, creating scalable applications, and managing data-driven solutions.",
    skills: [
      "MongoDB",
      "Express.js",
      "React.js",
      "Node.js",
      "Quality Control",
      "Data Analysis",
      "Process Improvement",
      "Workflow Optimization",
      "Web Development",
      "Data Automation",
    ],
    // doc: "https://drive.google.com/file/d/1684ICwPmFKW4IPGARm77uc6FYP3ElYKn/view?usp=sharing",
  },
  {
    id: 0,
    img: "https://i.pinimg.com/474x/ad/78/5a/ad785a9fb1587a496092b3d2f4e912b8.jpg",
    role: "Catalog Specialist",
    company: "Amazon Development Centre (India)PVT LTD",
    date: "Aug 2022 - Jan 2023",
    desc: "As an Catalog Specialist at Amazon Development Centre (India)PVT LTD from August 2022 to jan 2023, I gained valuable hands-on experience in handling Queries . Dedicated to maintaining high delivery standards, optimizing processes, and collaborating cross-functionally for efficient problem resolution. Skilled in quality management, effective communication, and data analysis. My expertise lies in ensuring top-tier service in the last mile of the delivery process.",
    skills: ["salesforce tool", "Geolocation", "Amazon tools"],
    // doc: "https://drive.google.com/file/d/1NasGR8nuhxTytKyRLDVH93gRQHm1DhXx/view?usp=drive_link",
  },
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmDWDFfv_gq1xG7ZnstVZu4q2c0zAbz4Dg_g&s",
    school: "V V College of Engineering, Tirunelveli",
    date: "Sep 2018 - July 2022",
    grade: "7.44 CGPA",
    degree:
      "Bachelor of Engineering - BE, Electronics and Communication Engineering",
  },
];

export const certifications = [
  {
    id: 0,
    img: "https://www.guvi.in/images/new-guvi-logo.png",
    school: "Guvi Geek Networks (IIT-M & IIM-A incubated EdTech), Chennai",
    date: "Dec 2023 - Apr 2024",
    grade: "89%",
    degree: "MERN Stack Development Certification",
  },
];

export const projects = [
  {
    id: 0,
    title: " Kitchen Recipe Management App",
    date: "Mar 2024",
    description:
      "Kitchen Recipe Management App, a web application designed to help you manage and organize your recipes efficiently.This web application allows users to manage their recipes, including adding, editing, and deleting recipes, and saving other recipes. making your cooking experience more enjoyable and organized.",
    image:
      "https://github.com/HarikaranSubramanian/Kitchen-Recipe-Management_Frontend/blob/main/public/assets/Screenshot%202024-04-11%20214212.png?raw=true",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "NodeMailer",
    ],
    category: "web app",
    github:
      "https://github.com/HarikaranSubramanian/Kitchen-Recipe-Management_Frontend",
    webapp: "https://netlify-kitchen-recipe-management.netlify.app/",
    member: [
      {
        name: "Harikaran",
        linkedin: "https://www.linkedin.com/in/harikaran-subramanian-profile/",
        github: "https://github.com/HarikaranSubramanian",
      },
    ],
  },
  {
    id: 1,
    title: "Todo-App",
    date: "Feb 2024",
    description:
      "Introducing my latest project: a dynamic Todo app featuring robust CRUD operations. Seamlessly manage tasks with create, read, update, and delete functionality. Experience streamlined productivity in a sleek and intuitive interface.",
    image:
      "https://github.com/HarikaranSubramanian/MyTodoApp/blob/main/Screenshot%202024-04-11%20223718.png?raw=true",
    tags: ["React Js"],
    category: "web app",
    github: "https://github.com/HarikaranSubramanian/MyTodoApp.git",
    webapp: "https://mytodo-netlify.netlify.app/",
  },
  {
    id: 2,
    title: "Book Data Management System",
    date: "Feb 2024 - Present",
    description:
      "This is a simple CRUD application built with HTML, CSS, JavaScript, and React for managing book data. It allows users to perform Create, Read, Update, and Delete (CRUD) operations on book records. The application uses Formik for form validation and integrates with a backend API for data storage and retrieval.",
    image:
      "https://github.com/HarikaranSubramanian/React-Formik-Task/blob/main/Screenshot%202024-04-11%20224950.png?raw=true",
    tags: ["React Js", "Mockapi"],
    category: "web app",
    github: "https://github.com/HarikaranSubramanian/React-Formik-Task.git",
    webapp: "https://netlify-formik.netlify.app/home",
  },
];

export const TimeLineData = [
  { year: 2022, text: "Started my journey" },
  { year: 2023, text: "Shared my projects with the world" },
];
